Hop.defineModule('signin-mandatory', (root) => {
    function addListener() {
        root.addEventListener('click', showSigninModal);
    }

    function showSigninModal(e) {
        const target = e.currentTarget;
        const isConnected = target.getAttribute('data-is-connected');
        // From what I can see, the data-is-connected is only used for search pagination
        if (isConnected !== 'true') {
            e.preventDefault();
            e.stopImmediatePropagation();

            const body = document.querySelector('body');
            const ff4jSignupEntrypointRedirection = body.hasAttribute('data-ff4j-signup-entrypoint-redirection');
            const path = window.location.pathname;
            const search = window.location.search;
            const isUrlFromProposal = path.includes('proposal');

            const urlToRedirect = isUrlFromProposal ? `/signup-client/email?redirect=${path}` : `/who-are-you?redirect=${path}${search}`;

            const signupRedirectPath = ff4jSignupEntrypointRedirection ? urlToRedirect : null;

            Hop.connect.control.showSigninPopup(target, false, signupRedirectPath);
        }
    }

    addListener();

    return function destroy() {
        root.removeEventListener('click', showSigninModal);
    };
});
